import { Routes, Route, Navigate } from 'react-router-dom'
import Home from '../pages/Home'
import About from '../pages/About'
import Safaris from '../pages/Safaris';
import Prints from '../pages/Prints';
import Blog from '../pages/Blog';
import Publications from '../pages/Publications';
import NotFound from '../components/NotFound/NotFound';
import Other from '../pages/Other';
import Contact from '../pages/Contact';
import Portfolio from '../pages/Portfolio';
import BudgetLenseBlog from '../pages/BudgetLense_blog';
import FrogstarryBlog from '../pages/Frogstarry_blog';

//products
import Neluma from '../pages/Products/Neluma';
import PerfectView from '../pages/Products/PerfectView';
import Sunkissed from '../pages/Products/Sunkissed';
import ImHome from '../pages/Products/ImHome';
import HuntGoals from '../pages/Products/HuntGoals';
import BraveFearless from '../pages/Products/BraveFearless';

//safari blogs
import WildlifePhotography from '../pages/SafariBlogs/WildlifePhotography';
import YalaNationalPark from '../pages/SafariBlogs/Yala';
import WilpattuNationalPark from '../pages/SafariBlogs/Wilpattu';
import SinharajaNationalPark from '../pages/SafariBlogs/Sinharaja';
import HerpingTours from '../pages/SafariBlogs/Herping';
import HortonPlains from '../pages/SafariBlogs/Horton';

const Routers = ()=>{
    return <Routes>
        <Route path='/' element={<Navigate to="home" />} />
        <Route path='/home' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/safaris' element={<Safaris />} />
        <Route path='/prints' element={<Prints />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/publications' element={<Publications />} />
        <Route path='/wildlife-photography-workshops-and-lectures' element={<Other />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/portfolio' element={<Portfolio />} />

        {/* blog */}
        <Route path='/blog/budget-lens-for-macro-photography' element={<BudgetLenseBlog />} />
        <Route path='/blog/the-worlds-rarest-frogstarry-shrub-frogpseudophilautus-stellatus' element={<FrogstarryBlog />} />

        {/* print cards */}
        <Route path='/product/perfect-view-comfort-rating' element={<PerfectView />} />
        <Route path='/product/the-perfect-amount-of-sunkissed' element={<Sunkissed />} />
        <Route path='/product/neluma' element={<Neluma />} />
        <Route path='/product/tell-the-wild-im-home' element={<ImHome />} />
        <Route path='/product/hunt-goals-not-set' element={<HuntGoals />} />
        <Route path='/product/brave-fearless-bold-strong' element={<BraveFearless />} />

        {/* safari blogs */}

        <Route path='/customized-wildlife-photography-learning-tour' element={<WildlifePhotography />} />
        <Route path='/yala-national-park' element={<YalaNationalPark />} />
        <Route path='/wilpattu-national-park' element={<WilpattuNationalPark />} />
        <Route path='/sinharaja-bird-watching' element={<SinharajaNationalPark />} />
        <Route path='/herping-tours' element={<HerpingTours />} />
        <Route path='/horton-plains-national-park' element={<HortonPlains />} />

        {/* 404 error */}
        <Route path='*' element={<NotFound />} />
    </Routes>
};

export default Routers;